const CAROUSEL_ITEMS = [
  {
    title: '2024 年度韩漫大赏',
    desc: '盘点今年最受欢迎的韩国漫画，从甜宠到悬疑，总有一部让你欲罢不能。',
    tags: ['年度盘点', '韩漫'],
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20illustration%20in%20Korean%20webtoon%20style%20featuring%20multiple%20characters%20from%20different%20genres%20gathered%20together%20in%20a%20festive%20celebration%20scene%2C%20warm%20golden%20lighting%2C%20clean%20composition%2C%20creamy%20background%2C%20editorial%20quality%2C%20no%20text%2C%20artistic%20manga%20style%20promotional%20image&width=1000&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '国漫崛起：那些不容错过的佳作',
    desc: '从修仙到科幻，国产漫画正以惊人的速度崛起，这些作品值得你一看。',
    tags: ['国漫精选', '推荐'],
    img: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20manhua%20style%20illustration%20showcasing%20epic%20fantasy%20elements%20with%20traditional%20Chinese%20architecture%20and%20floating%20mountains%2C%20dramatic%20golden%20and%20coral%20lighting%2C%20cinematic%20composition%2C%20soft%20cream%20background%2C%20editorial%20quality%2C%20no%20text%2C%20promotional%20manga%20art&width=1000&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '日漫经典：那些陪伴青春的漫画',
    desc: '热血、友情、冒险——日漫经典永不过时，一起重温那些感动过我们的故事。',
    tags: ['日漫经典', '怀旧'],
    img: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20Japanese%20manga%20style%20illustration%20with%20warm%20retro%20tones%20showing%20a%20group%20of%20young%20adventurers%20in%20a%20sunset%20scene%2C%20emotional%20atmosphere%2C%20clean%20composition%2C%20creamy%20background%2C%20editorial%20quality%2C%20no%20text%2C%20artistic%20manga%20promotional%20image&width=1000&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '悬疑漫画：烧脑解谜之夜',
    desc: '准备好你的大脑，这些悬疑推理漫画将带你走进错综复杂的谜案世界。',
    tags: ['悬疑推理', '专题'],
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20and%20atmospheric%20manga%20style%20illustration%20with%20dark%20warm%20tones%20showing%20a%20detective%20character%20in%20a%20dimly%20lit%20room%20with%20clues%20scattered%20around%2C%20suspenseful%20mood%2C%20clean%20composition%2C%20cream%20and%20deep%20brown%20background%2C%20editorial%20quality%2C%20no%20text%2C%20artistic%20manga%20promotional%20image&width=1000&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    title: '甜宠恋爱：甜到牙疼的漫画合集',
    desc: '高糖预警！这些恋爱漫画甜度爆表，适合在悠闲午后一边喝茶一边慢慢品味。',
    tags: ['恋爱甜宠', '合集'],
    img: 'https://readdy.ai/api/search-image?query=A%20sweet%20and%20romantic%20manga%20style%20illustration%20with%20soft%20pink%20and%20cream%20tones%20showing%20a%20couple%20in%20a%20cherry%20blossom%20garden%20scene%2C%20dreamy%20atmosphere%2C%20clean%20composition%2C%20warm%20background%2C%20editorial%20quality%2C%20no%20text%2C%20artistic%20manga%20promotional%20image&width=1000&height=600&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          编辑精选专题推荐，发现更多精彩漫画世界
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CAROUSEL_ITEMS.slice(0, 3).map((item) => (
            <article key={item.title} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer transition-all hover:-translate-y-1">
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex flex-wrap gap-1.5">
                  {item.tags.map((t) => (
                    <span key={t} className="px-2 py-0.5 text-xs font-medium bg-background-50/90 text-primary-600 rounded whitespace-nowrap">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 mb-1.5 font-heading">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {CAROUSEL_ITEMS.slice(3).map((item) => (
            <article key={item.title} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer transition-all hover:-translate-y-1">
              <div className="flex flex-col sm:flex-row">
                <div className="relative w-full sm:w-48 aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 flex-1">
                  <div className="flex flex-wrap gap-1.5 mb-2">
                    {item.tags.map((t) => (
                      <span key={t} className="px-2 py-0.5 text-xs bg-primary-100 text-primary-600 rounded whitespace-nowrap">
                        {t}
                      </span>
                    ))}
                  </div>
                  <h3 className="text-sm font-bold text-foreground-900 mb-1.5 font-heading">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}